import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";

export const use3DViewStore = defineStore('3dViewStore', {
    state: () => ({
        link: null,
        show: false,
        animation_in_progress: false,
        iframeLoaded: false,
    }),
    actions: {
        showPopup(link) {
            this.link = link
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(true)
            this.animation_in_progress = false
            this.iframeLoaded = false
            this.show = true

            let vm = this
            setTimeout(function () {
                vm.animation_in_progress = true
            }, 50)
        },
        closePopup() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(false)
            this.animation_in_progress = false
            this.iframeLoaded = false
            this.show = false
            this.animation_in_progress = true
            this.link = null
        },
    }
});
